import React, { FunctionComponent, useContext } from 'react'
import { Collapse, Divider, List, Switch } from 'antd'
import RACSAndCounties, { RAC } from '../../../../../utils/layers/RACs'
import CountyFeature from './types/CountyFeature'
import { useMap } from '@vis.gl/react-google-maps'
import { panMapBounds } from '../../../../../utils/googlemaps'
import { MapSettingsContext } from '../../../../../contexts/MapSettingsContext'
import MapSettingsContextInterface from '../../../../../contexts/MapSettingsContext/MapSettingsContextInterface'

const RACsAndCountiesOption: FunctionComponent<any> = () => {
  const map = useMap()

  const { activeCounties, setActiveCounties } = useContext(MapSettingsContext) as MapSettingsContextInterface

  const handleAllRACs = (e: boolean, event: any) => {
    event.stopPropagation()
    setActiveCounties((prevState: Map<string, CountyFeature>) => {
      if (e) {
        for (const RACKey of Object.keys(RACSAndCounties)) {
          const RAC = RACSAndCounties[RACKey]
          for (const countyKey of Object.keys(RAC.counties)) {
            const countyFeature = RAC.counties[countyKey]
            countyFeature.color = RAC.color
            prevState.set(countyKey, countyFeature)
          }
        }
        return new Map(prevState)
      } else {
        return new Map()
      }
    })
  }

  return (
    <List
      dataSource={[
        {
          key: 'all',
          label: 'All',
          extra: (
            <Switch
              checked={Object.values(RACSAndCounties).every((rac: RAC) => {
                return Object.keys(rac.counties).every((countyKey: any) => {
                  return activeCounties.has(countyKey)
                })
              })}
              onChange={handleAllRACs}
            />
          )
        }
      ]}
      renderItem={(data: any) => {
        return (
          <>
            <Divider orientation="left">RACs and Counties</Divider>
            <List.Item extra={data.extra}>
              <List.Item.Meta title={data.label} />
            </List.Item>
            <Collapse
              items={Object.keys(RACSAndCounties).map((racKey: string) => {
                const RAC: RAC = RACSAndCounties[racKey]
                const handleRACChange = (e: boolean, event: any) => {
                  event.stopPropagation()
                  const counties = RAC.counties
                  if (e) {
                    map?.panTo(RAC.center)
                    map?.setZoom(RAC.zoom)
                  }
                  setActiveCounties((prevState: Map<string, CountyFeature>) => {
                    for (const countyKey of Object.keys(counties)) {
                      const countyFeature = counties[countyKey]
                      if (e) {
                        countyFeature.color = RAC.color
                        prevState.set(countyKey, countyFeature)
                      } else {
                        prevState.delete(countyKey)
                      }
                    }
                    return new Map(prevState)
                  })
                }

                const children = Object.keys(RAC.counties).map((countyKey: string) => {
                  const countyFeature = RAC.counties[countyKey]
                  countyFeature.color = RAC.color
                  const coordArray = countyFeature.geometry.coordinates[0][0]
                  const latLngs = coordArray.map((coord: [number, number]) => {
                    return new google.maps.LatLng(coord[1], coord[0])
                  })
                  const handleCountyChange = (e: boolean) => {
                    setActiveCounties((prevState: Map<string, CountyFeature>) => {
                      if (e) {
                        prevState.set(countyKey, countyFeature)
                        return new Map(prevState)
                      } else {
                        prevState.delete(countyKey)
                        return new Map(prevState)
                      }
                    })
                    if (!map) return
                    if (e) panMapBounds(map, latLngs)
                  }
                  const label = countyKey.replace('_', ' ')

                  return {
                    key: countyKey,
                    title: `${label}`,
                    extra: (
                      <Switch
                        checked={activeCounties.has(countyKey)}
                        onChange={(e) => handleCountyChange(e)}
                      />
                    )
                  }
                })

                return {
                  key: racKey,
                  label: `${racKey.replace('_', ' ')} (${RAC.name})`,
                  extra: (
                    <Switch
                      checked={Object.keys(RAC.counties).every((countyKey: any) => {
                        return activeCounties.has(countyKey)
                      })}
                      onChange={handleRACChange}
                    />
                  ),
                  children: (
                    <List
                      dataSource={children}
                      renderItem={(data: any) => (
                        <List.Item extra={data.extra}>
                          <List.Item.Meta title={data.title} />
                        </List.Item>
                      )}
                    />
                  )
                }
              })}
            />
          </>
        )
      }}
    />
  )
}

export default RACsAndCountiesOption
